export default {
  id: 117,
  title: 'Target #117 - Arineo',
  url: 'https://cssbattle.dev/play/117',
  colors: ['#FFFFFF', '#0088CA', '#2E2926'],
  solution:
    '<a a><a b><a c><a d><a e><a f><style>[c],[d]{height:51;background:#fff}[c],[e]{left:120;width:80;transform:skewy(45deg)}[d],[f]{left:200;width:120;transform:skewy(-45deg)}[e],[f]{height:28;background:#0088ca}[a],[b]{top:60;width:44;height:180;background:#2e2926}body{background:radial-gradient(circle,#0088ca 11px,#fff 11px)}a{position:fixed}[a]{left:134;transform:skew(-25deg)}[b]{right:134;transform:skew(25deg)}[c]{top:138}[d]{top:118}[e]{top:150}[f]{top:130}</style>',
}
